import { Controller } from "stimulus"
import RequestQueue from 'classes/RequestQueue'
import _ from 'lodash';
import Utility from 'classes/Utility';
class SetupController extends Controller {
  async initialize() {
    window.MConstants = Object.assign({
      table: {},
      cta: {},
      adUnits: {},
      adTargets: {},
      configs: []
    }, window.MConstants || {});

    EventManager.on('mitre-ad-refresh', (options = {}) => {
      // adNames are ad unit names
      // adUnits are ad unit objects
      const { adNames, adUnits, allVisibleAds } = options;

      const refreshAd = () => {
        let adSlots = [];
        if (adUnits) {
          adSlots = adUnits;
        }
        if (adNames) {
          adNames.forEach(adName => {
            adSlots = _.union(adSlots, (window.MConstants.adUnits[adName]));
          })
        }
        if (allVisibleAds) {
          const allAds = _.values(window.MConstants.adUnits).flat();
          const visibleAds = allAds.filter(adSlot => (
            Utility.isVisible(document.getElementById(adSlot.getSlotElementId())) ||
            Utility.isVisible(document.querySelector(`[data-ad-position-id="${adSlot.getAdUnitPath()}"]`))
          ))
          adSlots = _.union(adSlots, visibleAds);
        }
        if (adSlots.length > 0) {
          adSlots.forEach(unit => {
            document.querySelectorAll(`[data-ad-position-id="${unit.getAdUnitPath()}"]`).forEach(adPositionDom => {
              adPositionDom.style.display = 'none'
            })
          })
          googletag.pubads().refresh(adSlots);
        }
      }
      if ('googletag' in window) {
        refreshAd();
      } else {
        EventManager.on('google_ad_loaded', refreshAd);
      }
    })

    window.addEventListener('message', event => {
      const { data } = event;
      const { eventName, adUnit, content, options } = data;
      if (eventName === 'MitreAdContentAvailable') {
        EventManager.emit('mitre-ad-loaded', {
          adUnit: adUnit,
          data: content,
          options: options
        })
      }
    });

    const configs = [
      {
        type: 'master_switch',
        name: 'Welcome Interstitial'
      },
      {
        type: 'isPremium'
      },
      {
        type: 'current_user'
      },
      {
        type: 'membership'
      },
      {
        type: 'access_groups'
      },
      {
        type: 'setting',
        fields: ['google_analytics', 'account_id']
      },
      {
        type: 'website', fields: ['google_cse']
      }
    ]

    // Make All-In-One request for shared configuration needs
    const { data } = await RequestQueue.addToQueue({
      url: '/api/configuration/',
      method: 'post',
      data: {
        configs
      },
      cached: true
    })

    configs.forEach((config, index) => {
      window.MConstants.configs.push(
        Object.assign({response: { data: data[index]} }, config)
      )
    })
    EventManager.emit('config_data_loaded');
  }
}

export default SetupController;
